export const START_FETCHING_TALENTS = 'redux/talents/START_FETCHING_TALENTS';
export const SUCCESS_FETCHING_TALENTS = 'redux/talents/SUCCESS_FETCHING_TALENTS';
export const ERROR_FETCHING_TALENTS = 'redux/talents/ERROR_FETCHING_TALENTS';
export const SET_KEYWORD = 'redux/talents/SET_KEYWORD';